import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './Input.module.css';
import TextArea from 'containers/UI/TextArea/TextArea';
import { formImages } from 'shared/utility';

const input = (props) => {
  let inputElement = null;
  const inputClasses = [classes.InputElement, classes[props.className]];
  if (props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push(classes.Invalid);
  }
  if (props.selected === true) {
    inputClasses.push(classes.Selected);
  }
  if (props.highlightPlaceholerOnValidationError && props.invalid && props.shouldValidate) inputClasses.push(classes.PlaceholderAlert);

  const inputContainerClasses = [classes.Input];
  const inputOuterContainerClasses = [classes.OuterInputContainer];
  if (props.label && props.label.length > 0) inputContainerClasses.push(classes.Labelled);
  if (props.inputClassName !== null) {
    inputContainerClasses.push(classes[props.inputClassName]);
    inputOuterContainerClasses.push(classes[props.inputClassName]);
  }
  if (props.isGift === true) inputContainerClasses.push(classes.GiftPost);
  if (props.icon || props.iconText || props.fontIcon) inputContainerClasses.push(classes.IconField);

  let validationError = null;
  if (props.validationError && props.invalid && props.touched && props.shouldValidate) {
    validationError = <p className={classes.ValidationError}>{props.validationError}</p>;
  }
  let guideText = null;
  if (props.guidetext && validationError == null) {
    guideText = <p className={classes.GuideText}>{props.guidetext}</p>;
  }
  let iconImage = props.iconImage ? formImages.find((formImage) => formImage.name === props.iconImage) : null;
  iconImage = props.fontIcon ? (
    <FontAwesomeIcon icon={props.fontIcon} className={classes.InputFontIcon} onClick={props.iconClicked ? props.iconClicked : undefined} />
  ) : iconImage ? (
    <iconImage.image className={classes.ImageIcon} onClick={props.iconClicked ? props.iconClicked : undefined} />
  ) : null;

  switch (props.elementType) {
    case 'input':
      inputElement = (
        <div className={inputContainerClasses.join(' ')}>
          <input
            className={inputClasses.join(' ')}
            {...props.elementConfig}
            value={props.value}
            type={props.revealPassword ? 'input' : props.elementConfig ? props.elementConfig.type : ''}
            name={props.elementConfig ? props.elementConfig.type : ''}
            autoComplete={props.elementConfig && props.elementConfig.autocomplete ? props.elementConfig.autocomplete : null}
            onChange={props.changed}
            onBlur={props.blurred}
            onClick={props.clicked}
            placeholder={props.placeholder}
            readOnly={props.readOnly}
          />
          {iconImage}
        </div>
      );
      break;
    case 'textarea':
      inputElement = (
        <div className={inputContainerClasses.join(' ')}>
          <TextArea
            className={props.className}
            selected={props.selected}
            value={props.value}
            isGift={props.isGift}
            minRows={props.elementConfig.minRows !== null ? props.elementConfig.minRows : 2}
            maxRows={props.elementConfig.maxRows !== null ? props.elementConfig.maxRows : 10}
            initialRows={props.elementConfig.initialRows !== null ? props.elementConfig.initialRows : 3}
            changed={props.changed}
            onBlur={props.blurred}
            placeholder={props.placeholder}
            clicked={props.clicked}
            readOnly={props.readOnly}
            key={props.key}
          />

          {iconImage}
        </div>
      );
      break;
    case 'select':
      inputElement = (
        <select className={inputClasses.join(' ')} value={props.value} onChange={props.changed} onBlur={props.blurred}>
          {props.elementConfig.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    case 'controlled':
      inputElement = (
        <div>
          <input
            className={inputClasses.join(' ')}
            {...props.elementConfig}
            value={props.value}
            key={props.key}
            onClick={props.clicked}
            placeholder={props.placeholder}
            readOnly={props.readOnly}
          />
          {iconImage}
        </div>
      );
      break;

    default:
      inputElement = (
        <div className={inputContainerClasses.join(' ')}>
          <input
            className={inputClasses.join(' ')}
            {...props.elementConfig}
            value={props.value}
            onChange={props.changed}
            onBlur={props.blurred}
            key={props.key}
            onClick={props.clicked}
            placeholder={props.placeholder}
            readOnly={props.readOnly}
            iconclicked={props.iconclicked}
          />
          {iconImage}
        </div>
      );
  }

  return (
    <div className={inputOuterContainerClasses.join(' ')}>
      <label>{props.label}</label>
      {inputElement}
      {guideText}
      {validationError}
    </div>
  );
};

export default input;
